<template>
	<div>
		<div id="help-support" class="text-left">
			<div id="help-support-title">
				<h3>Contact</h3>
			</div>
			<div id="help-support-text" class="m-t-xl">
				<p>
					Please contact us in case you need any additional information about
					Solar Forecasting Tool. You may be also interested in browsing our
					<span class="help-link">Help & Support</span> and other useful content
					by clicking on the menu items.
				</p>
			</div>

			<div v-if="validator_error">
				<div class="alert">
					<div>
						<span>{{ validator_error }}</span>
						<div class="alert-close" v-on:click="validator_error = null">
							<font-awesome-icon
								style="cursor:pointer;margin-top:5px;"
								size="lg"
								icon="times"
							/>
						</div>
					</div>
				</div>
			</div>

			<div v-if="success" class="success m-t-sm">
				<div>
					<span
						>Your contact information has been sent. We'll contact you as soon
						as posible.</span
					>
					<div class="alert-close" v-on:click="success = null">
						<font-awesome-icon
							style="cursor:pointer;margin-top:5px;"
							size="lg"
							icon="times"
						/>
					</div>
				</div>
			</div>

			<div class="m-t-xl">
				<div class="contact-label">
					Name or alias (optional)
				</div>
				<div class="contact-input">
					<input type="text" v-model.number="contact_data.name" />
				</div>
				<div class="clear"></div>
			</div>
			<div class="m-t">
				<div class="contact-label">
					Email
				</div>
				<div class="contact-input">
					<input type="text" v-model.number="contact_data.mail" />
				</div>
				<div class="clear"></div>
			</div>
			<div class="m-t">
				<div class="contact-label">
					Subject
				</div>
				<div class="contact-input">
					<input type="text" v-model.number="contact_data.subject" />
				</div>
				<div class="clear"></div>
			</div>
			<div class="m-t-lg">
				<div class="contact-label">
					Message
				</div>
				<div class="contact-input">
					<textarea v-model.number="contact_data.message" />
				</div>
				<div class="clear"></div>
			</div>

			<div v-if="sending_contact" class="m-t margin-center text-center">
				<span>Sending contact information...</span>
				<font-awesome-icon class="m-l" icon="spinner" pulse />
			</div>

			<div v-else style="width:150px;margin-right: 125px;" class="right m-t-lg">
				<CustomButton text="Send" @click.native="send_contact(contact_data)" />
			</div>
		</div>
	</div>
</template>

<script>
import ContactService from "@/services/ContactService";
import CustomButton from "@/components/sub-components/CustomButton";
import ContactValidator from "@/classes/contact";

export default {
	name: "NewLocation",
	components: {
		CustomButton
	},
	data() {
		return {
			contact_data: {
				name: undefined,
				mail: undefined,
				subject: undefined,
				message: undefined
			},
			validator_error: null,
			sending_contact: null,
			success: null
		};
	},
	methods: {
		send_contact: async function(contact_data) {
			var result = ContactValidator.validate(contact_data);
			if (result.error) {
				this.validator_error = result.error.message;
				return;
			}
			this.sending_contact = true;
			try {
				await ContactService.send_email(contact_data);
				this.success = true;
			} catch (e) {
				this.validator_error =
					"Error sending the contact information. Please try it again later.";
			} finally {
				this.sending_contact = null;
			}
		}
	}
};
</script>

<style>
#help-support {
	max-width: 800px;
	margin: 40px auto 0;
	color: white;
}
#help-support-title {
	font-size: 24px;
	font-weight: bold;
}
#help-support-text p {
	line-height: 24px;
	font-size: 16px;
	margin-bottom: 30px;
	font-weight: 500;
}
.help-link {
	color: #8079ff;
}
.contact-label {
	font-weight: 500;
	width: 300px;
	float: left;
	text-align: right;
	padding-top: 7px;
}
.contact-input {
	float: left;
	width: 350px;
	margin-left: 15px;
}
.contact-input input {
	color: white;
	background-color: transparent;
	outline: 0;
	border: 1px solid rgba(255, 255, 255, 0.4);
	width: 100%;
	height: 25px;
	line-height: 25px;
	padding: 5px;
	border-radius: 0;
	font-size: 18px;
}
.contact-input textarea {
	color: white;
	background-color: transparent;
	border: 1px solid grey;
	width: 100%;
	height: 200px;
	font-size: 16px;
}
</style>
